<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">
          {{ $t('school.academic.setup.program.grade.next_grade') }}
        </h4>
        <ts-modal-close-button />
      </div>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-6">
            <div class="m-b-15">
              <label>
                {{ $t('school.academic.setup.program.grade.main_program') }}
                <i
                  class="fas fa-question-circle"
                  v-tooltip="
                    $t(
                      'school.academic.setup.program.grade.select_main_program_to_filter_sub_program'
                    )
                  "
                ></i>
                <i class="fas fa-spinner spin" v-if="ready_fetch"></i>
              </label>
              <select
                class="form-control"
                v-model="model.acp_id"
                @change="onMainProgramChange(model.acp_id)"
              >
                <option value="">--Select--</option>
                <option
                  v-for="(main, index) in main_programs"
                  :key="index"
                  :value="main.acp_id"
                >
                  {{ main.acp_name_foreign }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="m-b-15">
              <label>
                {{ $t('school.academic.setup.program.grade.sub_program') }}
                <i
                  class="fas fa-question-circle"
                  v-tooltip="
                    $t(
                      'school.academic.setup.program.grade.select_sub_program_to_filter_level'
                    )
                  "
                ></i>
                <i class="fas fa-spinner spin" v-if="fetch_sub"></i>
              </label>
              <select
                class="form-control"
                v-model="model.acps_id"
                @change="onSubProgramChange(model.acps_id)"
              >
                <option value="">--selec--</option>
                <option
                  v-for="(sub, index) in sub_programs"
                  :key="index"
                  :value="sub.acps_id"
                >
                  {{ sub.acps_name_foreign }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="m-b-15">
              <label class="required">
                {{ $t('school.academic.setup.program.grade.level') }}
                <i class="fas fa-spinner spin" v-if="fetch_level"></i>
              </label>
              <select
                class="form-control"
                :class="{ 'is-invalid': errors.has('level_id') }"
                v-model.number="model.level_id"
                @change="getGradeBaseOnSubProgram"
              >
                <option value="">--selec--</option>
                <option
                  v-for="(level, index) in levels"
                  :key="index"
                  :value="level.level_id"
                >
                  {{ level.level_name_foreign }}
                </option>
              </select>
              <div class="invalid-feedback" v-if="errors.has('level_id')">
                {{ errors.first('level_id') }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <table class="table ui-table m-b-15">
              <thead>
                <tr>
                  <th style="width:50%">
                    {{ $t('school.academic.setup.program.grade.grade') }}
                  </th>
                  <th>
                    {{ $t('school.academic.setup.program.grade.next_grade') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="fetch_grade">
                  <td colspan="2" class="text-center">
                    <i class="fas fa-spinner spin"></i>
                  </td>
                </tr>
                <tr v-for="(grade, index) in model.grade_id_list" :key="index">
                  <td>{{ grade.grade_name_foreign }}</td>
                  <td class="text-center">
                    <select
                      v-model="grade.next_grade_id"
                      class="form-control only-border-bottom"
                      :class="{
                        'is-invalid': errors.has(
                          'grade_id_list.' + index + '.next_grade_id'
                        )
                      }"
                    >
                      <option value="0">--select--</option>
                      <option
                        v-for="(next_grade, index) in model.grade_id_list"
                        :key="index"
                        :value="next_grade.grade_id"
                      >
                        {{ next_grade.grade_name_foreign }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      v-if="
                        errors.has('grade_id_list.' + index + '.next_grade_id')
                      "
                    >
                      {{
                        errors.first(
                          'grade_id_list.' + index + '.next_grade_id'
                        )
                      }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 text-right">
            <ts-button class="mr-2" @click.prevent="$emit('close')">
              {{ $t('cancel') }}
            </ts-button>
            <ts-button
              class="btn-primary mr-2"
              :waiting="waiting_new"
              @click.prevent="saveAddNew"
            >
              {{ $t('save_add_new') }}
            </ts-button>
            <ts-button
              class="btn-primary"
              :waiting="waiting"
              @click.prevent="store"
            >
              {{ $t('save') }}
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'next-grade',
  data() {
    return {
      model: {
        acp_id: '',
        acps_id: '',
        level_id: '',
        grade_id_list: []
      },
      errors: new Errors(),
      sub_programs: [],
      levels: [],
      waiting: false,
      waiting_new: false,
      ready_fetch: false,
      fetch_sub: false,
      fetch_level: false,
      fetch_grade: false
    }
  },
  async created() {
    await this.fetchResourceBeforeCreate()
  },
  computed: {
    ...mapState('grade', ['main_programs'])
  },
  methods: {
    fetchResourceBeforeCreate() {
      this.ready_fetch = true
      this.$store
        .dispatch('grade/dataBeforeCreate')
        .then(response => {
          this.ready_fetch = false
        })
        .catch(error => {
          this.ready_fetch = false
          this.$toasted.error(error.message)
        })
    },
    onMainProgramChange(acp_id) {
      this.model.acps_id = ''
      this.model.level_id = ''
      this.model.grade_id_list = []
      this.levels = []
      this.fetch_sub = true
      this.$store
        .dispatch('grade/getSubProgram', acp_id ? acp_id : 0)
        .then(response => {
          this.fetch_sub = false
          this.sub_programs = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.fetch_sub = false
        })
    },
    async onSubProgramChange(acps_id) {
      this.model.level_id = ''
      this.model.grade_id_list = []
      this.fetch_level = true
      let grade = await this.$store.dispatch(
        'grade/getLevel',
        acps_id ? acps_id : 0
      )
      this.levels = grade.data
      this.fetch_level = false
    },
    async getGradeBaseOnSubProgram() {
      if (!this.model.acps_id) {
        return
      }
      this.fetch_grade = true
      this.$store
        .dispatch('grade/getGrade', this.model.acps_id)
        .then(response => {
          this.model.grade_id_list = response.data
          this.fetch_grade = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.fetch_grade = false
        })
    },
    store() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('grade/nextGrade', this.model)
        .then(response => {
          this.waiting = false
          this.$toasted.success(response.message)
          this.fetchData()
          this.$emit('close')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    saveAddNew() {
      this.errors = new Errors()
      this.waiting_new = true
      this.$store
        .dispatch('grade/nextGrade', this.model)
        .then(response => {
          this.waiting_new = false
          this.$toasted.success(response.message)
          this.fetchData()
          this.clearInput()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting_new = false
        })
    },
    clearInput() {
      this.model = {
        acp_id: '',
        acps_id: '',
        level_id: '',
        grade_id_list: []
      }
      this.sub_programs = []
      this.levels = []
    },
    fetchData(attributes) {
      this.$store
        .dispatch('grade/fetch', attributes)
        .then(response => {})
        .catch(error => {
          this.$toasted.error(error.message)
        })
    }
  }
}
</script>

<style lang="css" scope>
	.table > thead > tr > th {
	  position: sticky;
		position: -webkit-sticky;
		top: 0;
		z-index: 999;
}
.table > tbody > tr > td{
	padding-top: 5px !important;
	padding-bottom: 5px !important;
	/* border: none !important */
}
.only-border-bottom {
	border-top: none;
	border-left: none;
	border-right: none;
}
</style>
